module.exports = __webpack_public_path__ + "static/media/Pic-0512.17e3b31a.jpg";